import React, { useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom'; 
import './Header.css';
import siteLogo from '../../assets/images/icon/site_logo.svg';
import siteLogoWhite from '../../assets/images/icon/site_logo_white.svg';
import xLogo from '../../assets/images/icon/x_logo.png';
import noteLogo from '../../assets/images/icon/note_logo.png';
import githubLogo from '../../assets/images/icon/github_logo.svg';
import ThemeToggle from '../ThemeToggle/ThemeToggle';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  // ハンバーガークリックで開閉切り替え
  const handleHamburgerClick = () => {
    setIsOpen(!isOpen);
  };

  // 共通のスクロール処理（遅延付き）を定義
  const delayedScroll = (el) => {
    setTimeout(() => {
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 150); // 150ミリ秒の遅延（必要に応じて調整）
  };



  return (
    <header id="header" className={isOpen ? 'nav-open' : ''}>
      {/* PCナビゲーション（PC版は既に正常に動作しているので HashLink を使用） */}
      <nav className="header-pc-nav">
        <div className="header-nav-content">
          <Link className="site-logo" to="/">
            <img src={siteLogo} alt="津田千穂のポートフォリオサイトのロゴ" />
          </Link>
          <ul className="gnav-menu">
            
            <li>
              <HashLink smooth className="menu-item" to="/#hotpick">
                HOT PICK
              </HashLink>
            </li>
            <li>
              <HashLink smooth className="menu-item" to="/#works">
                WORKS
              </HashLink>
            </li>
            <li>
              <HashLink smooth className="menu-item" to="/#about">
                ABOUT
              </HashLink>
            </li>
            {/*}
            <li>
              <HashLink smooth className="menu-item" to="/#blog">
                BLOG
              </HashLink>
            </li>
            */}
          </ul>
          {/* ダークモード切り替え */}
          {/*<ThemeToggle />*/}
        </div>
      </nav>

      {/* SPナビゲーション */}
      <nav className="header-sp-nav">
        <div className="header-nav-content_sp">
          {/* SPナビのロゴも HashLink にして、遅延付きスクロール */}
          <HashLink
            smooth
            scroll={delayedScroll}
            className="site-logo"
            to="/"
            onClick={() => setIsOpen(false)}
          >
            <img src={siteLogoWhite} alt="津田千穂のポートフォリオサイトのロゴ" />
          </HashLink>
          <ul className="sp-gnav-menu">
            <li>
              <HashLink
                smooth
                scroll={delayedScroll}
                className="menu-item"
                to="/#hotpick"
                onClick={() => setIsOpen(false)}
              >
                HOT PICK
              </HashLink>
            </li>
            <li>
              <HashLink
                smooth
                scroll={delayedScroll}
                className="menu-item"
                to="/#works"
                onClick={() => setIsOpen(false)}
              >
                WORKS
              </HashLink>
            </li>
            <li>
              <HashLink
                smooth
                scroll={delayedScroll}
                className="menu-item"
                to="/#about"
                onClick={() => setIsOpen(false)}
              >
                ABOUT
              </HashLink>
            </li>
            {/*
            <li>
              <HashLink
                smooth
                scroll={delayedScroll}
                className="menu-item"
                to="/#blog"
                onClick={() => setIsOpen(false)}
              >
                BLOG
              </HashLink>
            </li>
             */}
          </ul>

          {/* ダークモード切り替え */}
          <div className="sp-theme-toggle">
            {/*<ThemeToggle />*/}
          </div>


          <ul className="sp-sns-btn">
            <li>
              <a
                className="sns-btn-link"
                href="https://x.com/momo1530889"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="x" src={xLogo} alt="X" />
              </a>
            </li>
            <li>
              <a
                className="sns-btn-link"
                href="https://note.com/nice_camel636"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="note" src={noteLogo} alt="note" />
              </a>
            </li>
            <li>
              <a
                className="sns-btn-link"
                href="https://github.com/chiho883/chatbot"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="github"
                  src={githubLogo}
                  alt="GitHub"
                />
              </a>
            </li>
          </ul>
        </div>
        <div className="copyright">
          <p>© CHIHO TSUDA 2025</p>
        </div>
      </nav>

      {/* ハンバーガーメニュー */}
      <div className="hamburger-area">
        <div
          id="js-hamburger"
          className="humburger-btn"
          onClick={handleHamburgerClick}
        >
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
}

export default Header;